const React = require('react');
const isNode = (typeof process !== 'undefined');
const Select = isNode ? require('react-select') : <div/>;
const Input = require('./../../FormComponents/Input');

const typeOfParkingOptions = [
    { value: 'enkelplass', label: 'Enkelplass' },
    { value: 'dobbelplass', label: 'Dobbelplass' },
    { value: '2-separate', label: '2 separate plasser' },
    { value: 'mc-scooter', label: 'MC/Scooter' }
];
const rentPeriodOptions = [
    { value: 'langtidsleie', label: 'Langtidsleie' },
    { value: 'korttidsleie', label: 'Korttidsleie' }
];

const parkingAddressOptions = [
    { value: 'Trondheimsveien 197', label: 'Trondheimsveien 197' },
    { value: 'Hausmannsgate 19', label: 'Hausmannsgate 19' },
    { value: 'Breigata 10', label: 'Breigata 10' }
];

// This is actually Hausmannsgate. It changed value, so the variable is misnamed. Can't replace as it will affect older submitted forms.
const livesInT197Options = [
    { value: 'Ja', label: 'Ja' },
    { value: 'Nei', label: 'Nei' }
];

const livesInTrondheimsveien197Options = [
    { value: 'Ja', label: 'Ja' },
    { value: 'Nei', label: 'Nei' }
];

const livesInBreigata10Options = [
    { value: 'Ja', label: 'Ja' },
    { value: 'Nei', label: 'Nei' }
];

class GarasjePlass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typeOfParking: { value: null, label: null },
            parkingAddress: { value: null, label: null },
            rentPeriod: { value: null, label: null },
            livesInT197: { value: null, label: null },
            livesInTrondheimsveien197: { value: null, label: null },
            livesInBreigata10: { value: null, label: null },
        };

        this.setSelectedOption = this.setSelectedOption.bind(this);
    }
    getValues() {
        return {
            address: this.address.value,
            regNum: this.regNum.value,
            identityNumber: this.identityNumber.value,
            parkingAddress: this.state.parkingAddress.label,
            typeOfParking: this.state.typeOfParking.label,
            fromDate: this.fromDate.value,
            rentPeriod: this.state.rentPeriod.label,
            livesInT197: this.state.livesInT197.label,
            livesInTrondheimsveien197: this.state.livesInTrondheimsveien197.label,
            livesInBreigata10: this.state.livesInBreigata10.label,
            creditCheck: this.state.creditCheck
        }
    }
    setSelectedOption(name, option) {
        this.setState({ [name]: option });
    }
    render() {
        const {hideHeaders, color} = this.props;
        const selectedParkingAddress = this.state.parkingAddress && this.state.parkingAddress.value;
        const selectedTypeOfParking = this.state.typeOfParking && this.state.typeOfParking.value;

        // Rent period
        const selectedRentPeriod = this.state.rentPeriod && this.state.rentPeriod.value;
        const selectedLivesInT197 = this.state.livesInT197 && this.state.livesInT197.value;
        const selectedLivesInTrondheimsveien197 = this.state.livesInTrondheimsveien197 && this.state.livesInTrondheimsveien197.value;
        const selectedLivesInBreigata10 = this.state.livesInBreigata10 && this.state.livesInBreigata10.value;


        return (
        <div className={`forms__inputContainer forms__inputContainer--${color}`}>
            {!hideHeaders && <h2 className="forms__formHeader">Garasjeplass</h2>}
            <p className="forms__helpText">
                NB! Søknader vedr Breigata 12 sendes direkte til Qpark.
            </p>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="address"  type="text" placeholder="Adresse" ref={(address) => this.address = address}/>
            </div>
            <div className="forms__formElement">
                <Input validations={{ matchRegexp: /^(\d{9}|\d{11})$/ }} required name="identityNumber"  type="text" placeholder="Fødselsnummer (11-siffer)/organisasjonsnummer" ref={(identityNumber) => this.identityNumber = identityNumber}/>
            </div>
            <div className="forms__formElement">
                <Select value={selectedParkingAddress} onChange={(option) => this.setSelectedOption('parkingAddress', option)} name="parkingAddress" options={parkingAddressOptions} className="react-select-custom" placeholder="Parkeringsanleggets adresse"/>
            </div>
            <div className="forms__formElement">
                <Select value={selectedTypeOfParking} onChange={(option) => this.setSelectedOption('typeOfParking', option)} name="typeOfParking" options={typeOfParkingOptions} className="react-select-custom" placeholder="Type parkering"/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="fromDate"  type="text" placeholder="Ønsker å leie fra" ref={(fromDate) => this.fromDate = fromDate}/>
            </div>
            <div className="forms__formElement">
                <Select value={selectedRentPeriod} onChange={(option) => this.setSelectedOption('rentPeriod', option)} name="rentPeriod" options={rentPeriodOptions} className="react-select-custom" placeholder="Leietid"/>
            </div>
            <div className="forms__formElement">
                <Select value={selectedLivesInT197} onChange={(option) => this.setSelectedOption('livesInT197', option)} name="livesInT197" options={livesInT197Options} className="react-select-custom" placeholder="Jeg er beboer eller i arbeid i Hausmannsgate 19"/>
            </div>
            <div className="forms__formElement">
                <Select value={selectedLivesInTrondheimsveien197} onChange={(option) => this.setSelectedOption('livesInTrondheimsveien197', option)} name="livesInTrondheimsveien197" options={livesInTrondheimsveien197Options} className="react-select-custom" placeholder="Jeg er beboer i Trondheimsveien 197"/>
            </div>
            <div className="forms__formElement">
                <Select value={selectedLivesInBreigata10} onChange={(option) => this.setSelectedOption('livesInBreigata10', option)} name="livesInBreigata10" options={livesInBreigata10Options} className="react-select-custom" placeholder="Jeg er beboer i Breigata 10"/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="regNum"  type="text" placeholder="Reg.nr." ref={(regNum) => this.regNum = regNum}/>
            </div>
            <div className="forms__formElement">
                <label><input required type="checkbox" value={true} onChange={ev => this.setState({creditCheck: ev.target.checked})}/> Jeg samtykker til kredittsjekk</label>
            </div>
        </div>
        )
    }
}

module.exports = GarasjePlass;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/GarasjePlass/index.jsx